<template>
  <div>
    <notification-message class="notification" />

    <div class="updateListImports">
      <v-btn color="red darken-1" outlined @click="execSync()" class="mr-2">
        {{ $t("ImportsList.updateListImports") }}
      </v-btn>
      <v-btn color="red darken-1" outlined @click="truncate()" class="mr-2">
        {{ $t("ImportsList.clearTables") }}
      </v-btn>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="red darken-1"
      ></v-progress-circular>
    </div>

    <div class="layout">
      <div class="crudArray">
        <v-data-table
          :headers="headers"
          :items="imports"
          :server-items-length="totalItemCount"
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{
                $t("importsList.titleArray")
              }}</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
          </template>
          <template v-slot:[`item.failed`]="{ item }">
            <v-icon :color="item.failed ? 'red' : 'green'">
              {{
                item.failed
                  ? "mdi-close-circle-outline"
                  : "mdi-check-circle-outline"
              }}
            </v-icon>
          </template>
          <template v-slot:[`item.details`]="{ item }">
            <v-icon small class="mr-2" @click="goToDetails(item)">
              mdi-information
            </v-icon>
          </template>
          <template v-slot:[`item.back`]="{ item }">
            <v-icon small class="mr-2" @click="restore(item)">
              mdi-cached
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  getAllSyncHttp,
  execSyncImportHttp,
  truncateTablesImportHttp,
} from "@/services/planning/SyncService.js";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";
import i18n from "@/i18n";

export default {
  components: {
    NotificationMessage,
  },
  computed: {},
  data: () => ({
    search: "",
    imports: [],
    headers: [
      { text: i18n.t("importsList.hId"), value: "id", align: "center" },
      {
        text: i18n.t("importsList.hStart"),
        value: "start",
        align: "center",
      },
      {
        text: i18n.t("importsList.hStartOfSync"),
        value: "startOfSync",
      },
      {
        text: i18n.t("importsList.hEnd"),
        value: "end",
      },
      {
        text: i18n.t("importsList.hEndOfSync"),
        value: "endOfSync",
        sortable: true,
      },
      {
        text: i18n.t("importsList.hDurationInMilli"),
        value: "durationInMilli",
      },
      {
        text: i18n.t("importsList.hFailed"),
        value: "failed",
      },
      { text: i18n.t("importsList.hDetails"), value: "details" },
    ],
    editedIndex: -1,
    datePickerStart: false,
    datePickerEnd: false,
    options: {
      page: 1,
      itemsPerPage: 5,
    },
    totalItemCount: 20,
    showErrorMessage: false,
    errorMessage: "",
  }),
  created() {
    this.getAll();
  },
  methods: {
    ...mapActions("notificationModule", ["showNotification"]),
    ...mapActions(["fetchImportsDG2", "loadImports"]),

    async getAll() {
      await getAllSyncHttp().then((response) => {
        this.imports = response.data.slice(-10).reverse();
      });
    },
    goToDetails(item) {
      this.$router.push({ name: "ImportDetails", params: { id: item.id } });
    },

    //buton syncImport
    execSync() {
      execSyncImportHttp()
        .then((res) =>
          this.showNotification({
            messageAlert: "lunching import success",
            typeAlert: "success",
          })
        )
        .catch((error) =>
          this.showNotification({
            messageAlert: "lunching import failed",
            typeAlert: "error",
          })
        );
    },
    truncate() {
      truncateTablesImportHttp()
        .then((res) =>
          this.showNotification({
            messageAlert: "truncate tables success",
            typeAlert: "success",
          })
        )
        .catch((error) =>
          this.showNotification({
            messageAlert: "truncate tables failed",
            typeAlert: "error",
          })
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.notification {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 3% 11%;
}

.crudArray {
  margin: 0 auto 3rem auto;
  width: 80%;
}

.filterMemento {
  background-color: var(--card-color);
  margin: 2rem auto;
  width: 80%;
}

.errors {
  margin: 0;
  color: red !important;
}
.login-wdg2 {
  position: absolute;
  width: 30%;
  z-index: 3;
}

.updateListImports {
  display: flex;
  justify-content: center;
  padding: 2rem 0 0 0;
}
</style>
